import { marked } from 'marked';
import markedKatex from 'marked-katex-extension';
import 'katex/dist/katex.min.css';

// LaTeX in reason/condition fields: $inline$ or $$block$$ (standard
// delimiters only - no \( \) / \[ \]). throwOnError:false means a typo'd
// expression renders as reddish error text in place rather than blanking
// out the entire field's content.
marked.use(markedKatex({ throwOnError: false }));

// Indented (4-space/tab) code blocks are a CommonMark feature almost nobody
// invokes on purpose - here it just meant any accidentally-indented line
// (or nested-looking bullet) silently became a <pre> block. Disabling it
// only removes that legacy indentation rule; fenced ``` code blocks are a
// separate tokenizer rule and are unaffected.
// GFM strikethrough also accepts a *single* ~ as a delimiter (not just ~~),
// and pairs them up strictly by count regardless of distance or what's
// between them - two unrelated stray tildes several cells apart end up
// wrapping everything between them in <del>. Since a lone ~ has no other
// use in Markdown, disabling this tokenizer lets it stay a literal
// character; <del>/<s> tags remain available if strikethrough is ever
// wanted, same as any other raw HTML.
marked.use({
  tokenizer: {
    code() { return undefined; },
    del() { return undefined; }
  }
});

// marked wraps every paragraph in <p>...</p>, which carries its own default
// browser margin - stacked on top of existing content's own spacing/<br>
// tags, that reads as unwanted extra blank lines. Headings/lists/etc. keep
// their normal tags (their spacing is expected when actually used); only
// the plain-paragraph wrapper is suppressed.
const renderer = new marked.Renderer();
// Must be a regular function (not arrow) - marked calls this bound to the
// renderer instance, and `this.parser` is how you render a paragraph's
// inline tokens (bold/links/etc.) without going through the default
// <p>-wrapping implementation.
renderer.paragraph = function (token) {
  return this.parser.parseInline(token.tokens);
};

// Converts Markdown syntax to HTML while leaving embedded raw HTML tags
// untouched (CommonMark/GFM pass raw HTML through by design), so existing
// HTML-only content keeps rendering exactly as before. breaks:false (the
// default) is deliberate here - breaks:true would auto-insert a second
// <br> after every line you already ended with your own <br>.
export const renderMarkdown = text => marked.parse(text || '', { renderer });
